(function(){
    'use strict';
    angular.module('Services').factory('SharedServicesTableService', SharedServicesTableService);

    SharedServicesTableService.$inject = [
        'Carrier',
        'TableLiteFactory',
        '$location',
        '$q',
        'toastr',
        '$filter',
        '$rootScope'
    ];

    function SharedServicesTableService(
        Carrier,
        TableLiteFactory,
        $location,
        $q,
        toastr,
        $filter,
        $rootScope
    ) {
        return function (services, bridge = {}) {
            let selectedCarrierProfile = null;
            var tableStructure = {
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noTopOptions: false,
                    noFooter: false,
                    rowsUnclickable: false
                },
                headers: [
                    {
                        label: 'DISPLAY NAME IN QUOTES',
                        viewName: 'name',
                        filterName: 'name',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header))
                            },
                            model: ''
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'CARRIER PROFILE',
                        viewName: 'carrierProfileName',
                        filterName: 'carrierProfileId',
                        sortName: 'carrierProfile.id',
                        filter: {
                            type: 'autoComplete',
                            placeholder: 'Search',
                            viewName: 'name',
                            filterBy: 'id',
                            items: [], //List of items shown in dropdown
                            onSubmit: function (header) {
                                selectedCarrierProfile = this.model;
                                sendRequest(evaluateFilter(header));
                            },
                            refreshOnLoad: true,
                            refresh: function (model) {
                                const defer = $q.defer();
                                let selected = this.model;
                                let filterItems = this.items;
                                Carrier.getExternalCarrierProfiles((data) => {
                                    filterItems.length = 0;
                                    angular.forEach(data.content, (profile) => {
                                        if (profile.id === bridge.carrierProfileId) {
                                            selected.name = profile.name;
                                            tableStructure.optionAddOns.select.model = profile;
                                            bridge.carrierProfileId = null;
                                        }
                                        filterItems.push(profile);
                                    });
                                    defer.resolve();
                                }, (error) => {
                                    toastr.error('Unable to fetch carrier profiles', error.message);
                                    defer.reject();
                                }, {size: 10, name: model ? model : '', enabled: true});
                                return defer.promise;
                            },
                            model: bridge.carrierProfileId ? {name: ' '} : null
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'SERVICE',
                        viewName: 'serviceName',
                        filterName: 'serviceId',
                        filter: {
                            type: 'select2',
                            placeholder: 'Search',
                            viewName: 'name',
                            filterBy: 'id',
                            items: services, //List of items shown in dropdown
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'CARRIER ACCOUNT CODE',
                        viewName: 'carrierCode',
                        filterName: 'carrierAccountCode',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header))
                            },
                            model: ''
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'MARGIN FIXED',
                        viewName: 'marginFixed'
                    },
                    {
                        label: 'MARGIN (%)',
                        viewName: 'marginPercent'
                    },{
                        label: 'CURRENCY',
                        viewName: 'currencyFormatted'
                    }
                ],
                data: [],
                onInit: function () {
                    let profileId = bridge.carrierProfileId;
                    if (bridge.carrierProfileId) {
                        sendRequest({carrierProfileId: profileId});
                    }
                    sendRequest({});
                },
                resetFilters: function () {
                    selectedCarrierProfile = null;
                    resetFilters();
                },
                rowOnClick: function (item) {
                    bridge.viewProfile(item)
                }
            };
            const tableActions = new TableLiteFactory(tableStructure,
                {
                    serviceCallback: Carrier.getServiceProfiles,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        size: 10,
                        page: 0,
                        sort: 'id,desc',
                        enabled: true
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const resetFilters = tableActions.resetFilters;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (row, index) {
                    row.button = {
                        type: 'button',
                        buttons: [{
                            text: 'View / Edit',
                            class: 'btn btn-primary',
                            action: function () {
                                /* fixme */
                            }
                        }]
                    };
                    const currency = row.currency || $rootScope.GlobalProfile.office.currency || 'AUD';


                    row.currentFuelLevy = angular.getObjVal(row, 'fuelLevy.details') ?
                        angular.getObjVal(row, 'fuelLevy.details.name') :  'N/A';

                    row.marginFixed = angular.getObjVal(row, 'fuelLevy.details') && angular.getObjVal(row, 'fuelLevy.details.fixed') !== null ?
                        $filter('bbaCurrency')(angular.getObjVal(row, 'fuelLevy.details.fixed'), currency) : `0.00 ${currency}`;

                    row.marginPercent = angular.getObjVal(row, 'fuelLevy.details') && angular.getObjVal(row, 'fuelLevy.details.percentage') !== null ?
                        angular.getObjVal(row, 'fuelLevy.details.percentage') + ' %' : '0 %';

                    row.serviceName = angular.getObjVal(row, 'service.name') || 'N/A';
                    row.carrierProfileName = angular.getObjVal(row, 'carrierProfile.name') || 'N/A';
                    row.carrierCode = row.carrierAccountCode || 'N/A';
                    row.status = row.status = {
                        type: 'status',
                        status: row.active,
                        label: row.active ? 'Enabled' : 'Disabled'
                    };
                    row.currencyFormatted = row.currency ? row.currency.toUpperCase() : 'AUD';
                    tableStructure.data.push(row);
                });
            };
            this.tableData = tableStructure;
        };
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/SharedServicesTable.js